import UIDs from "../../../../UIDs";

const uid = UIDs.screens.studyletter.practice;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    LOAD_PRACTICE_RESULT_ASYNC: `${uid}.loadPracticeResultAsync`,
    LOAD_PRACTICE_RESULT_SUCCESS: `${uid}.loadPracticeResultSuccess`,
    LOAD_PRACTICE_RESULT_FAILURE: `${uid}.loadPracticeResultFailure`,
    REPORT_RESULT: `${uid}.reportResult`,
    NEXT_UNIT: `${uid}.nextUnit`,
    UPDATE_LOCAL_RESULT_ASYNC: `${uid}.updateLocalResultAsync`,
    UPDATE_LOCAL_RESULT_SUCCESS: `${uid}.updateLocalResultSuccess`,
    UPDATE_LOCAL_RESULT_FAILURE: `${uid}.updateLocalResultFailure`,
    UPDATE_UNIT_RESULT_ASYNC: `${uid}.updateUnitResultAsync`,
    UPDATE_UNIT_RESULT_SUCCESS: `${uid}.updateUnitResultSuccess`,
    UPDATE_UNIT_RESULT_FAILURE: `${uid}.updateUnitResultFailure`,
    SHOW_FOOTER: `${uid}.showFooter`,
    SHOW_COMMON_MODAL_REF: `${uid}.showCommonModalRef`,
    UPDATE_SETTINGS: `${uid}.updateSettings`,
    SHOW_PRACTICE_RESULT: `${uid}.showPracticeResult`,
    RESTART_ASYNC: `${uid}.restartAsync`,
    RESTART_ASYNC_SUCCESS: `${uid}.restartAsyncSuccess`,
    RESTART_ASYNC_FAILURE: `${uid}.restartAsyncFailure`,
    COMPLETE_ASYNC: `${uid}.completeAsync`,
    COMPLETE_ASYNC_SUCCESS: `${uid}.completeAsyncSuccess`,
    COMPLETE_ASYNC_FAILURE: `${uid}.completeAsyncFailure`,
};

export { ActionTypes };
